import { Dispatch } from "redux";
import { saveAuthTokens, saveTempToken, clearAuthTokens, clearTempToken } from "helpers/tokenStorage";
import { RootState } from "../index";
import { types } from "../types/types";

export const setUserAuthTokens = (accessToken: string, refreshToken?: string) => {
  saveAuthTokens(accessToken, refreshToken ?? "");
  return {
    type: types.user,
    payload: {
      accessToken,
      refreshToken,
      tempToken: "",
    },
  };
};

export const local = (user: any) => {

  // eslint-disable-next-line no-param-reassign
  delete user.password;
  return {
    type: types.userDt,
    payload: {
      user,
    },
  };
};

export const setTempToken = (tempToken: string) => {
  saveTempToken(tempToken);
  return {
    type: types.setTempToken,
    payload: {
      tempToken,
    },
  };
};

export const logout = () => (dispatch: Dispatch, getState: () => RootState) => {
  clearAuthTokens();
  dispatch({
    type: types.logout,
  });

  const { tempToken } = getState().userReducer;
  if (!tempToken) {
    dispatch({
      type: types.financialFormRemove,
    });
  }
};

export const expireTempToken = () => (dispatch: Dispatch, getState: () => RootState) => {
  clearTempToken();
  dispatch({
    type: types.tempTokenExpired,
  });

  const { accessToken } = getState().userReducer;
  if (!accessToken) {
    dispatch({
      type: types.financialFormRemove,
    });
  }
};
